import { render, staticRenderFns } from "./Updater.vue?vue&type=template&id=7baa47ba&scoped=true&"
import script from "./Updater.vue?vue&type=script&lang=ts&"
export * from "./Updater.vue?vue&type=script&lang=ts&"
import style0 from "./Updater.vue?vue&type=style&index=0&id=7baa47ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baa47ba",
  null
  
)

export default component.exports